import { useMemo } from 'react';
import { DeleteButton } from './delete/DeleteButton.jsx';
import { PdfButton } from './pdf/PdfButton.jsx';
import { ShapefileButton } from './shapefile/ShapefileButton.jsx';
import { FourRButton } from './fourR/FourRButton.jsx';
import { LpkRunButton } from './runLpk/LpkRunButton.jsx';
import { DeereButton } from './deere/DeereButton.jsx';
import { CsvButton } from './csv/CsvButton.jsx';
import { RenameButton } from './rename/RenameButton.jsx';

export function useActions() {
  const actions = useMemo(
    () => [
      <LpkRunButton />,
      <RenameButton />,
      <DeleteButton />,
      <ShapefileButton keep-open="true" />,
      <CsvButton keep-open="true" />,
      <PdfButton keep-open="true" />,
      <FourRButton />,
      <DeereButton />,
    ],
    [],
  );

  return { actions };
}
